import React from 'react';
import { Platform, StyleSheet, View } from 'react-native';

import { Container, theme, useResponsive } from '@sg/garnish';

import { AccountMenu, PageWrapper } from '../../components';
import { AccountScreenHeader } from './components';

// ─────────────────────────────────────────────────────────────────────────────

export const AccountScreenContent = () => {
  const { currentBreakpoint } = useResponsive();

  // ─── Flags ───────────────────────────────────────────────────────────

  // ─── Derived ───────────────────────────────────────────────────────────────

  const shouldRenderScreenHeader = currentBreakpoint.isXS;

  // ─────────────────────────────────────────────────────────────────────

  return (
    <View style={styles.container}>
      {shouldRenderScreenHeader ? <AccountScreenHeader /> : null}

      <PageWrapper
        style={styles.pageWrapper}
        safeAreaEdges={shouldRenderScreenHeader ? undefined : ['top']}
        safeAreaViewStyle={accountSafeAreaViewStyle}
      >
        <Container>
          <AccountMenu />
        </Container>
      </PageWrapper>
    </View>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: theme.colors.APP_BACKGROUND,
  },
  pageWrapper: {
    flex: 1,
    backgroundColor: theme.colors.APP_BACKGROUND,
  },
  contentContainer: {
    paddingVertical: theme.spacing['4'],
  },
  safeAreaView: {
    maxHeight: undefined, // overrides default style
  },
});

const accountSafeAreaViewStyle = Platform.select({ native: styles.safeAreaView });
